export default __webpack_public_path__ + "static/media/Q3_2021_Market_Report.94408107.pdf";